import { z } from "zod";

/** Historical evidence from independent verification; it does not establish current page state. */
export const browserActionVerificationReceiptSchema = z.object({
  outcome: z.enum(["completed", "failed", "unknown"]),
  evidence: z.string().max(240),
  resultText: z.string().max(1200),
  verifiedAtMs: z.number().int(),
});

export const browserActionOutcomeSchema = z.object({
  artifactId: z.string(),
  site: z.string(),
  action: z.string(),
  consequence: z.string(),
  status: z.enum([
    "waitingForUserAction",
    "inProgress",
    "completed",
    "cancelled",
    "failed",
    "outcomeUnknown",
    "updated",
  ]),
  error: z.string().optional(),
  verification: browserActionVerificationReceiptSchema.optional(),
});
export type BrowserActionOutcome = z.infer<typeof browserActionOutcomeSchema>;
